import React from "react";
import "./filtroDeporte.sass";

export default function FiltroDeporte({ seleccionarFiltroCompetencias, dataCompetencias }) {

    return (

        <div className="container-filtros-envivo" id={"filtros-envivo-deporte"}>
            {/* SELECT DEPORTES / COMPETENCIAS */}
            <div className="select-filtro-competencia">
                <select onChange={seleccionarFiltroCompetencias}>
                    {dataCompetencias &&
                        dataCompetencias.map((competencia) => (
                            <option key={competencia.id} value={competencia.slug}>
                                {competencia.name}
                            </option>
                        ))}
                </select>
            </div>
        </div>

    );
}
